export enum ReportType {
    CitationCountByDate = 20,
    CitationStatusReport = 21,
    CitationsPaidSummaryByDate = 22,
    CitationsPaidOnline = 23,
    VoidedCitationsByDate = 24,
    Top20Violators = 25,
    OnlinePaymentsByLot = 26,
    ReconciliationSummary = 27,
    ReconciliationDetail = 28,
    CitationHoldCandidates = 29,
    LotCheckDetail = 30,
    ScofflawReport = 31,
    GapReport = 32,
    LetterSummary = 33,
    OnlinePaymentsDetail = 34,
    BootsTowsPending = 35,
    BootTowReport = 36,
    CurrentBaggingReport = 41,
    OfficerReport = 57,
    PlateSearchReport = 58,
    ByTheNumbersReport = 66,
    GapandScofflawReport = 70,
    VoidsSummaryReport = 77,
    ViolationsByLocationsSummary = 90,
    HearingBondReport = 91,
    AgingBreakdownReport = 92,
    CollectionsPayments = 100,
    CollectionVoids = 102,
    CollectionAdjustments = 103,
    DMVSummary = 104,
    QuickStats = 105,
    AgingDetailReport = 106,
    AgingByYearReport = 107,
    ConvenienceFeeReport = 116,
    MonthlyStatement = 117,
    DuplicateStateReport = 118,
    WarningReport = 122,
    ByTheNumbersComparisonReport = 123,
    PaidHandicappedParking = 131,
    ManualCitationReport = 134
}
